import RTokenOverview from './components/rtoken-overview'

const Settings = () => {
  return (
    <div className="relative grid grid-cols-1 gap-5 p-1 sm:p-6 justify-center content-start items-start">
      <RTokenOverview />
    </div>
  )
}

export default Settings
